import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "offcanvas offcanvas-end description-sources-panel",
  tabindex: "-1",
  ref: "panel"
}
const _hoisted_2 = { class: "offcanvas-body" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-start gap-2"
}
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = { class: "small text-muted ps-3 mb-3" }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = { class: "mb-1" }
const _hoisted_8 = { class: "small text-muted mb-2" }
const _hoisted_9 = { class: "btn btn-sm btn-primary mb-0" }
const _hoisted_10 = ["accept"]
const _hoisted_11 = { class: "d-flex gap-2 mb-3" }
const _hoisted_12 = {
  key: 1,
  class: "card card-body mb-3"
}
const _hoisted_13 = {
  key: 0,
  class: "small text-muted"
}
const _hoisted_14 = ["id", "value", "disabled"]
const _hoisted_15 = ["for"]
const _hoisted_16 = {
  key: 0,
  class: "small text-muted"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 2,
  class: "card card-body mb-3"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "list-group mb-2" }
const _hoisted_21 = { class: "d-flex flex-column" }
const _hoisted_22 = ["disabled", "onClick"]
const _hoisted_23 = ["disabled", "onClick"]
const _hoisted_24 = { class: "flex-grow-1 small text-truncate" }
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2 align-middle",
  role: "status"
}
const _hoisted_29 = { class: "card-body d-flex gap-3 p-3" }
const _hoisted_30 = { class: "flex-grow-1" }
const _hoisted_31 = { class: "fw-semibold" }
const _hoisted_32 = ["aria-valuenow", "aria-valuemax"]
const _hoisted_33 = {
  key: 0,
  class: "small text-muted"
}
const _hoisted_34 = {
  key: 1,
  class: "small text-muted"
}
const _hoisted_35 = {
  key: 2,
  class: "small text-muted"
}
const _hoisted_36 = {
  key: 3,
  class: "small text-muted mt-1"
}
const _hoisted_37 = {
  key: 5,
  class: "card border-success-subtle bg-success-subtle mb-2"
}
const _hoisted_38 = { class: "card-body d-flex align-items-center gap-3 p-3" }
const _hoisted_39 = { class: "flex-grow-1" }
const _hoisted_40 = { class: "fw-semibold" }
const _hoisted_41 = { class: "small text-muted" }
const _hoisted_42 = {
  key: 6,
  class: "text-muted small"
}
const _hoisted_43 = {
  key: 7,
  class: "text-muted small"
}
const _hoisted_44 = {
  key: 8,
  class: "list-group"
}
const _hoisted_45 = { class: "d-flex flex-column" }
const _hoisted_46 = ["disabled", "onClick"]
const _hoisted_47 = ["disabled", "onClick"]
const _hoisted_48 = { class: "flex-grow-1 small min-width-0" }
const _hoisted_49 = { class: "fw-semibold text-truncate" }
const _hoisted_50 = {
  key: 0,
  class: "text-muted text-truncate"
}
const _hoisted_51 = { class: "small text-nowrap" }
const _hoisted_52 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_53 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_54 = {
  key: 2,
  class: "text-success"
}
const _hoisted_55 = { class: "dropdown" }
const _hoisted_56 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { key: 1 }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { key: 2 }
const _hoisted_62 = ["href"]
const _hoisted_63 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[46] || (_cache[46] = _createStaticVNode("<div class=\"offcanvas-header border-bottom\"><div><h5 class=\"offcanvas-title\"><span class=\"fas fa-magic me-2 text-primary\"></span>Vyplnit s pomocí AI</h5><div class=\"small text-muted\">Nahrajte podklady k nemovitosti, AI z nich vyčte hodnoty pro formulář.</div></div><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"offcanvas\" aria-label=\"Zavřít\"></button></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.errorMessage !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "aria-label": "Zavřít",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.errorMessage = null))
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("ol", _hoisted_5, [
        _createElementVNode("li", _hoisted_6, [
          _cache[13] || (_cache[13] = _createElementVNode("strong", { class: "text-body" }, "Přidejte podklady", -1)),
          _createTextVNode(": výkresy, výpis z katastru, inzerát, text, nahrávku z prohlídky nebo přílohy, které už odhad má. Můžete jich přidat víc najednou, snímek obrazovky vložíte přes " + _toDisplayString(_ctx.pasteShortcut) + ". ", 1)
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("li", { class: "mb-1" }, [
          _createElementVNode("strong", { class: "text-body" }, "Pojmenujte je"),
          _createTextVNode(", třeba „1. NP“ nebo „LV“. Popisek pomůže AI poznat, co podklad popisuje, hlavně u výkresů jednotlivých podlaží. ")
        ], -1)),
        _createElementVNode("li", _hoisted_7, [
          _cache[14] || (_cache[14] = _createElementVNode("strong", { class: "text-body" }, "Spusťte zpracování.", -1)),
          _createTextVNode(" Každý podklad stojí " + _toDisplayString(_ctx.creditCost) + " " + _toDisplayString(_ctx.plural(_ctx.creditCost, 'kredit', 'kredity', 'kreditů')) + " a čte se zvlášť, obvykle desítky sekund. Formulář mezitím můžete dál vyplňovat. ", 1)
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("li", { class: "mb-1" }, [
          _createElementVNode("strong", { class: "text-body" }, "Převezměte hodnoty."),
          _createTextVNode(" V okně zaškrtnete, co převzít. Hodnotu můžete před převzetím opravit, podlahovou plochu z více výkresů poskládat po podlažích. Bez vás se nic nezapíše a převzatá pole zůstanou označená k ověření. ")
        ], -1)),
        _cache[17] || (_cache[17] = _createElementVNode("li", null, [
          _createElementVNode("strong", { class: "text-body" }, "Vraťte se k nim kdykoli"),
          _createTextVNode(": přes „Hodnoty z podkladů“ nad formulářem nebo přes odkaz „v podkladech N jiné hodnoty“ u pole. ")
        ], -1))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["description-sources-dropzone p-4 text-center mb-2", {'dragover': _ctx.dragover}]),
        onDragover: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.dragover = true), ["prevent"])),
        onDragleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dragover = false)),
        onDrop: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"]))
      }, [
        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "fas fa-upload fa-2x text-primary mb-2" }, null, -1)),
        _cache[20] || (_cache[20] = _createElementVNode("div", null, [
          _createTextVNode("Přetáhněte sem i "),
          _createElementVNode("strong", null, "více souborů najednou")
        ], -1)),
        _createElementVNode("div", _hoisted_8, " PDF, fotky, výkresy, txt, zvuk, do 15 MB; snímek obrazovky nebo text vložíte přes " + _toDisplayString(_ctx.pasteShortcut), 1),
        _createElementVNode("label", _hoisted_9, [
          _cache[18] || (_cache[18] = _createTextVNode(" Vybrat soubory ", -1)),
          _createElementVNode("input", {
            type: "file",
            multiple: "",
            class: "d-none",
            accept: _ctx.ACCEPTED_FILES,
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFilesSelected && _ctx.onFilesSelected(...args)))
          }, null, 40, _hoisted_10)
        ])
      ], 34),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-sm flex-fill", _ctx.picker === 'attachments' ? 'btn-secondary' : 'btn-outline-secondary']),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.togglePicker('attachments')))
        }, [...(_cache[21] || (_cache[21] = [
          _createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1),
          _createTextVNode("Z příloh odhadu ", -1)
        ]))], 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-sm flex-fill", _ctx.picker === 'text' ? 'btn-secondary' : 'btn-outline-secondary']),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.togglePicker('text')))
        }, [...(_cache[22] || (_cache[22] = [
          _createElementVNode("span", { class: "fas fa-align-left me-2" }, null, -1),
          _createTextVNode("Vložit text ", -1)
        ]))], 2)
      ]),
      (_ctx.picker === 'attachments')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "small text-muted mb-2" }, "Soubory, které už odhad má, nic se nenahrává znovu.", -1)),
            (_ctx.attachments.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Odhad zatím nemá žádné přílohy."))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attachments, (attachment) => {
              return (_openBlock(), _createElementBlock("div", {
                key: attachment.id,
                class: "form-check"
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: 'description-source-attachment-' + attachment.id,
                  value: attachment.id,
                  disabled: _ctx.usedAttachmentIds.has(attachment.id),
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedAttachmentIds) = $event))
                }, null, 8, _hoisted_14), [
                  [_vModelCheckbox, _ctx.selectedAttachmentIds]
                ]),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: 'description-source-attachment-' + attachment.id
                }, [
                  _createTextVNode(_toDisplayString(_ctx.attachmentName(attachment)) + " ", 1),
                  (_ctx.usedAttachmentIds.has(attachment.id))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, ", už v podkladech"))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_15)
              ]))
            }), 128)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-primary mt-2 align-self-start",
              disabled: _ctx.selectedAttachmentIds.length === 0,
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.queueAttachments && _ctx.queueAttachments(...args)))
            }, "Přidat vybrané", 8, _hoisted_17)
          ]))
        : _createCommentVNode("", true),
      (_ctx.picker === 'text')
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control mb-2",
              rows: "4",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.text) = $event)),
              placeholder: "Např. text inzerátu nebo poznámky z prohlídky"
            }, null, 512), [
              [_vModelText, _ctx.text]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-outline-primary align-self-start",
              disabled: _ctx.text.trim() === '',
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.queueText && _ctx.queueText(...args)))
            }, "Přidat text", 8, _hoisted_19)
          ]))
        : _createCommentVNode("", true),
      (_ctx.queue.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _cache[27] || (_cache[27] = _createElementVNode("h6", { class: "text-muted text-uppercase small fw-semibold" }, "Připraveno ke zpracování", -1)),
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.queue, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.key,
                  class: "list-group-item d-flex align-items-center gap-2"
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-link p-0",
                      disabled: index === 0,
                      "aria-label": "Posunout nahoru",
                      onClick: ($event: any) => (_ctx.moveQueued(index, -1))
                    }, [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("span", { class: "fas fa-chevron-up" }, null, -1)
                    ]))], 8, _hoisted_22),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-link p-0",
                      disabled: index === _ctx.queue.length - 1,
                      "aria-label": "Posunout dolů",
                      onClick: ($event: any) => (_ctx.moveQueued(index, 1))
                    }, [...(_cache[25] || (_cache[25] = [
                      _createElementVNode("span", { class: "fas fa-chevron-down" }, null, -1)
                    ]))], 8, _hoisted_23)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass([_ctx.queuedIcon(item), "text-secondary"])
                  }, null, 2),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(item.name), 1),
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control form-control-sm w-25",
                    placeholder: "popisek, např. 1. NP",
                    "onUpdate:modelValue": ($event: any) => ((item.source.label) = $event)
                  }, null, 8, _hoisted_25), [
                    [_vModelText, item.source.label]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-link text-danger",
                    "aria-label": "Odebrat",
                    onClick: ($event: any) => (_ctx.queue.splice(index, 1))
                  }, [...(_cache[26] || (_cache[26] = [
                    _createElementVNode("span", { class: "fas fa-times" }, null, -1)
                  ]))], 8, _hoisted_26)
                ]))
              }), 128))
            ]),
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "small text-muted mb-2" }, "Popisek AI dostane jako nápovědu, co podklad popisuje.", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success w-100 mb-1",
              disabled: _ctx.processing,
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.processQueue && _ctx.processQueue(...args)))
            }, [
              (_ctx.processing)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                : _createCommentVNode("", true),
              _createTextVNode(" Zpracovat " + _toDisplayString(_ctx.queue.length) + " " + _toDisplayString(_ctx.plural(_ctx.queue.length, 'podklad', 'podklady', 'podkladů')) + ", " + _toDisplayString(_ctx.queueCost) + " " + _toDisplayString(_ctx.plural(_ctx.queueCost, 'kredit', 'kredity', 'kreditů')), 1)
            ], 8, _hoisted_27),
            _createElementVNode("div", {
              class: _normalizeClass(["small mb-3", _ctx.creditBalance < _ctx.queueCost ? 'text-danger' : 'text-muted'])
            }, " Zůstatek " + _toDisplayString(_ctx.creditBalance) + " " + _toDisplayString(_ctx.plural(_ctx.creditBalance, 'kredit', 'kredity', 'kreditů')), 3)
          ], 64))
        : _createCommentVNode("", true),
      _cache[45] || (_cache[45] = _createElementVNode("h6", { class: "text-muted text-uppercase small fw-semibold" }, "Podklady odhadu", -1)),
      (_ctx.batch.total > 0 && _ctx.batch.processing)
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: _normalizeClass(["card mb-2", _ctx.batchIsSlow ? 'border-warning-subtle bg-warning-subtle' : 'description-sources-progress-card'])
          }, [
            _createElementVNode("div", _hoisted_29, [
              _cache[32] || (_cache[32] = _createStaticVNode("<div class=\"description-sources-progress-art\" aria-hidden=\"true\"><div class=\"sheet\"></div><div class=\"sheet\"></div><div class=\"sheet\"><div class=\"line\"></div><div class=\"line\"></div><div class=\"line\"></div><div class=\"line\"></div><div class=\"beam\"></div></div><span class=\"fas fa-magic spark\"></span></div>", 1)),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, "AI čte podklady, hotovo " + _toDisplayString(_ctx.batch.done) + " z " + _toDisplayString(_ctx.batch.total), 1),
                _createElementVNode("div", {
                  class: "progress my-2 description-sources-progress",
                  role: "progressbar",
                  "aria-valuenow": _ctx.batch.done,
                  "aria-valuemin": "0",
                  "aria-valuemax": _ctx.batch.total
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar progress-bar-striped progress-bar-animated",
                    style: _normalizeStyle({width: Math.max(_ctx.batch.done / _ctx.batch.total * 100, 5) + '%'})
                  }, null, 4)
                ], 8, _hoisted_32),
                (_ctx.batchIsSlow)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, " Trvá to déle než obvykle, zpracování ale pořád běží. Když skončí chybou, podklad zkusíte znovu a kredity se za něj znovu nestrhnou. "))
                  : (_ctx.batch.audio)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [...(_cache[29] || (_cache[29] = [
                        _createTextVNode(" Nahrávku z prohlídky AI nejdřív přepíše do textu a pak z něj vyčte hodnoty. ", -1),
                        _createElementVNode("strong", { class: "text-body" }, "Podle délky nahrávky trvá celé čtení obvykle 5–10 minut.", -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_35, [...(_cache[30] || (_cache[30] = [
                        _createTextVNode(" Z každého podkladu AI vyčítá plochy, dispozici, konstrukci a další hodnoty formuláře. Podle složitosti trvá jeden podklad obvykle 1–3 minuty, podrobné výkresy a delší PDF i déle. Podklady se čtou souběžně. ", -1),
                        _createElementVNode("strong", { class: "text-body" }, "Celé čtení obvykle trvá 2–5 minut.", -1)
                      ]))])),
                (!_ctx.batchIsSlow)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [...(_cache[31] || (_cache[31] = [
                      _createElementVNode("span", { class: "fas fa-info-circle me-1" }, null, -1),
                      _createTextVNode("Panel můžete zavřít a vyplňovat dál, čtení poběží. ", -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2))
        : (_ctx.batch.total > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "fas fa-check-circle fa-2x text-success" }, null, -1)),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, " Podklady jsou přečtené, AI našla " + _toDisplayString(_ctx.batch.parameterCount) + " " + _toDisplayString(_ctx.plural(_ctx.batch.parameterCount, 'hodnotu', 'hodnoty', 'hodnot')), 1),
                  _createElementVNode("div", _hoisted_41, [
                    (_ctx.batch.failed > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.batch.failed) + " " + _toDisplayString(_ctx.plural(_ctx.batch.failed, 'podklad', 'podklady', 'podkladů')) + " se nepodařilo přečíst, zkuste " + _toDisplayString(_ctx.batch.failed === 1 ? 'ho' : 'je') + " znovu v menu u řádku. ", 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("Do formuláře se zapíší až po vašem převzetí.")
                        ], 64))
                  ])
                ]),
                (_ctx.batch.parameterCount > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-sm btn-success text-nowrap",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('show-found-values', null)))
                    }, "Převzít hodnoty"))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [...(_cache[34] || (_cache[34] = [
            _createElementVNode("span", {
              class: "spinner-border spinner-border-sm me-2 align-middle",
              role: "status"
            }, null, -1),
            _createTextVNode("Načítání… ", -1)
          ]))]))
        : (_ctx.sources.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, "Odhad zatím nemá žádné podklady."))
          : (_openBlock(), _createElementBlock("div", _hoisted_44, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sources, (source, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: source.id,
                  class: "list-group-item d-flex align-items-center gap-2"
                }, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-link p-0",
                      disabled: index === 0,
                      "aria-label": "Posunout nahoru",
                      onClick: ($event: any) => (_ctx.moveSource(source, index - 1))
                    }, [...(_cache[35] || (_cache[35] = [
                      _createElementVNode("span", { class: "fas fa-chevron-up" }, null, -1)
                    ]))], 8, _hoisted_46),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-link p-0",
                      disabled: index === _ctx.sources.length - 1,
                      "aria-label": "Posunout dolů",
                      onClick: ($event: any) => (_ctx.moveSource(source, index + 1))
                    }, [...(_cache[36] || (_cache[36] = [
                      _createElementVNode("span", { class: "fas fa-chevron-down" }, null, -1)
                    ]))], 8, _hoisted_47)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass([_ctx.sourceIcon(source), "text-secondary"])
                  }, null, 2),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, _toDisplayString(source.label !== '' ? source.label : _ctx.sourceName(source)), 1),
                    (source.label !== '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.sourceName(source)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    (source.state === 'processing')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_52, [...(_cache[37] || (_cache[37] = [
                          _createElementVNode("span", {
                            class: "spinner-border spinner-border-sm me-1 align-middle",
                            role: "status"
                          }, null, -1),
                          _createTextVNode("Čte se… ", -1)
                        ]))]))
                      : (source.state === 'error')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_53, [...(_cache[38] || (_cache[38] = [
                            _createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }, null, -1),
                            _createTextVNode("Chyba ", -1)
                          ]))]))
                        : (source.parameterCount !== null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                              _cache[39] || (_cache[39] = _createElementVNode("span", { class: "fas fa-check me-2" }, null, -1)),
                              _createTextVNode(_toDisplayString(source.parameterCount) + " " + _toDisplayString(_ctx.plural(source.parameterCount, 'hodnota', 'hodnoty', 'hodnot')), 1)
                            ]))
                          : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _cache[44] || (_cache[44] = _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-link text-secondary",
                      "data-bs-toggle": "dropdown",
                      "aria-label": "Akce"
                    }, [
                      _createElementVNode("span", { class: "fas fa-ellipsis-v" })
                    ], -1)),
                    _createElementVNode("ul", _hoisted_56, [
                      (source.state === 'error')
                        ? (_openBlock(), _createElementBlock("li", _hoisted_57, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "dropdown-item",
                              onClick: ($event: any) => (_ctx.retrySource(source))
                            }, [...(_cache[40] || (_cache[40] = [
                              _createElementVNode("span", { class: "fas fa-redo me-2" }, null, -1),
                              _createTextVNode("Zkusit znovu ", -1)
                            ]))], 8, _hoisted_58)
                          ]))
                        : _createCommentVNode("", true),
                      (source.state === 'completed' && (source.parameterCount ?? 0) > 0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_59, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "dropdown-item",
                              onClick: ($event: any) => (_ctx.$emit('show-found-values', source.id))
                            }, [...(_cache[41] || (_cache[41] = [
                              _createElementVNode("span", { class: "fas fa-magic me-2" }, null, -1),
                              _createTextVNode("Hodnoty z tohoto podkladu ", -1)
                            ]))], 8, _hoisted_60)
                          ]))
                        : _createCommentVNode("", true),
                      (source.url !== null)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_61, [
                            _createElementVNode("a", {
                              class: "dropdown-item",
                              href: source.url,
                              target: "_blank",
                              rel: "noopener"
                            }, [...(_cache[42] || (_cache[42] = [
                              _createElementVNode("span", { class: "fas fa-external-link-alt me-2" }, null, -1),
                              _createTextVNode("Zobrazit podklad ", -1)
                            ]))], 8, _hoisted_62)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "dropdown-item text-danger",
                          onClick: ($event: any) => (_ctx.removeSource(source))
                        }, [...(_cache[43] || (_cache[43] = [
                          _createElementVNode("span", { class: "fas fa-trash me-2" }, null, -1),
                          _createTextVNode("Odstranit podklad ", -1)
                        ]))], 8, _hoisted_63)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]))
    ])
  ], 512))
}